'use client'

import { useEffect } from 'react'
import { useUser } from '@clerk/nextjs'
import { initPostHog, posthog } from '@/lib/posthog'
import { useI18n } from '@/lib/i18n'

function PostHogIdentify() {
  const { isLoaded, isSignedIn, user } = useUser()
  const { locale } = useI18n()

  useEffect(() => {
    if (!isLoaded) return
    if (isSignedIn && user) {
      const email = user.primaryEmailAddress?.emailAddress
      const currentDistinctId = posthog.get_distinct_id?.()
      if (currentDistinctId !== user.id) {
        posthog.identify(user.id, {
          email,
          name: user.fullName,
          first_name: user.firstName,
          last_name: user.lastName,
          created_at: user.createdAt?.toISOString(),
          $set: {
            email,
            name: user.fullName,
            locale,
          },
          $set_once: {
            signup_at: user.createdAt?.toISOString(),
            signup_locale: locale,
          },
        })
      } else {
        // Already identified — keep locale in sync if user switched language.
        posthog.setPersonProperties({ locale })
      }
    } else if (isLoaded && !isSignedIn) {
      const distinctId = posthog.get_distinct_id?.()
      // Reset only if we previously identified (distinct_id is a Clerk user_*)
      if (typeof distinctId === 'string' && distinctId.startsWith('user_')) {
        posthog.reset()
      }
    }
  }, [isLoaded, isSignedIn, user, locale])

  return null
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initPostHog()
  }, [])

  return (
    <>
      <PostHogIdentify />
      {children}
    </>
  )
}
